// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames not based on template
	if (chunkId === 36) return "static/js/6b383a80290093f0bc60.bundle.js";
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"55":"df19134beb20d496b66d","176":"c8fde6e2538609baae07","177":"5f41fec53b199ad1e90d"}[chunkId] + ".chunk.js";
};